import { Request } from '@/http/request'

// 黑名单用户价格查询
export function getByUid(parameter: any){
  return Request.axiosInstance.post('/open/black-user-price/get-by-uid', parameter)
}

export default { getByUid }